import { ParkerClient, ParkerDTO, SetParkerStatusDTO } from "src/app/base/models/models.swagger.generated";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { TranslateService } from "@ngx-translate/core";
import { ParkerInfo } from "../parker-execution-status";
import { Observable, map, of } from "rxjs";

export class SetStatusExecutor extends ParkerFunctionExecutor {
  private _activeStatusToChange: boolean;

  constructor(numTotalRecordsToWorkOn: number, activeStatusToChange: boolean, private translateService: TranslateService, private parkerClient: ParkerClient) {
    super(numTotalRecordsToWorkOn);
    this._activeStatusToChange = activeStatusToChange;
  }

  protected prepare(): Observable<void> {
    return of(null); // nothing to prepare
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
    return this.parkerClient.setParkerStatus(new SetParkerStatusDTO({ id: parker.id, active: this._activeStatusToChange })).pipe(map(parker => parker.id));
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    var parkersToSetStatus: ParkerDTO[] = [];
    parkers?.forEach(parker => {
      if (this._activeStatusToChange === false && !parker.active) {
        this.executionStatus.push({
          status: 'warning',
          message: this.translateService.instant('i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.message-parker-not-active'),
          parkerInfo: new ParkerInfo(parker)
        });
      }
      else if (this._activeStatusToChange === true && parker.active) {
        this.executionStatus.push({
          status: 'warning',
          message: this.translateService.instant('i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.message-parker-already-active'),
          parkerInfo: new ParkerInfo(parker)
        });
      }
      else {
        parkersToSetStatus.push(parker);
      }
    });
    return parkersToSetStatus;
  }
}
